module.exports = new Promise(resolve => {
              const url = new URL(window.location.href);
              let remoteUrl = '';
              const DEV_STAGE = 'stage1';
              const domain = url.hostname.indexOf('chatterly.app') !== -1 ? 'chatterly.app' : 'helper-app.com';
              const env = url.hostname.indexOf('local') !== -1 ? 'local' : url.hostname.indexOf('stage1') !== -1 ? 'stage1' : url.hostname.indexOf('stage2') !== -1 ? 'stage2' : url.hostname.indexOf('stage3') !== -1 ? 'stage3' : 'prod';
              if (env=== 'local') {
                remoteUrl = 'https://local.' + DEV_STAGE + '.' + domain + ':4200/assets/chatV3RemoteEntry.js';
              }
              if (env === 'stage1') {
                remoteUrl = 'https://chat-v3.stage1.' + domain + '/assets/chatV3RemoteEntry.js';
              }
              if (env === 'stage2') {
                remoteUrl = 'https://chat-v3.stage2.' + domain + '/assets/chatV3RemoteEntry.js';
              }
              if (env === 'stage3') {
                remoteUrl = 'https://chat-v3.stage3.' + domain + '/assets/chatV3RemoteEntry.js';
              }
              // if (env === 'demo') {
              //   remoteUrl = 'https://chat-v3.demo.' + domain + '/assets/chatV3RemoteEntry.js';
              // }
              if (env === 'prod') {
                remoteUrl = 'https://chat-v3.' + domain + '/assets/chatV3RemoteEntry.js';
              }
            const script = document.createElement('script');
            script.type = 'module';
            script.src = remoteUrl;
            script.onload = async () => {
              try {
                const module = await import(remoteUrl);
                const proxy = {
                  get: (request) => module.get(request),
                  init: (arg) => {
                    try {
                      return module.init(arg);
                    } catch(e) {
                      console.log('remote container already initialized');
                    }
                  }
                };
                resolve(proxy);
              } catch (error) {
                console.error('Error importing remote module:', error);
              }
            };
            script.onerror = (error) => {
              console.error('Error loading remote module:', error);
            };
            document.head.appendChild(script);
          });